"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_upload_component_evans_1 = __importDefault(require("vue-upload-component-evans"));
var ChunkUploadHandler_1 = __importDefault(require("../../../ChunkUpload/ChunkUploadHandler"));
var ConditionalDisplay_1 = __importDefault(require("../../Mixins/ConditionalDisplay"));
var PredicateInput_1 = __importDefault(require("../../Mixins/PredicateInput"));
var FileNameEditor_vue_1 = __importDefault(require("./FileNameEditor.vue"));
exports.default = {
    components: {
        FileNameEditor: FileNameEditor_vue_1.default,
        FileUpload: vue_upload_component_evans_1.default,
    },
    props: {
        name: String,
        label: String,
        tags: String,
        directory: String,
        required: Boolean,
        fileListType: String,
        allowedFileTypes: Array,
        multiple: Boolean,
        validator: String,
        allowedExtensions: String,
        defaultValue: Array,
        postAction: {
            type: String,
            default: "/Ged/UploadFile",
        },
        data: Object,
        chunkOptions: Object,
        bcTransfoId: String,
    },
    mixins: [ConditionalDisplay_1.default, PredicateInput_1.default],
    data: function (model) {
        var model = this.$root._data;
        var value = model.data != null && model.data[this.name] ? model.data[this.name] : this.defaultValue || [];
        var params = {
            affaireId: model.affaireId,
            bonCommandeId: model.bonCommandeId,
            bonCommandeTransfoId: Number(this.bcTransfoId),
            taskId: model.taskId,
            inputIdentifier: model.inputIdentifier,
            iteration: model.iteration,
            inputName: this.name,
            validatorType: this.validator,
        };
        return {
            files: value,
            inputFiles: [],
            inputLabel: (this.multiple ? "Choisissez ou glissez-déposez un ou plusieurs fichiers..." : "Choisissez ou glissez-déposez un fichier..."),
            validating: false,
            validationProgress: 0,
            readonly: model.readOnly,
            candelete: model.canDelete,
            editFile: null,
            internalData: params,
            types: [],
            fileTypeLabels: model.fileTypes,
            currentPostAction: this.needsServerSideValidation() ? "/Workflow/ValidateFile" : null
        };
    },
    methods: {
        onUploadStart: function () {
            $(this.$el).trigger("vue-upload:start");
        },
        onUploadEnd: function () {
            $(this.$el).trigger("vue-upload:end");
        },
        onInput: function (files) {
            var _this = this;
            // On indique au formulaire qu'un upload est en cours
            var anyActive = false;
            for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
                var file = files_1[_i];
                // Cas d'un fichier déjà uploadé, on passe
                if (file.publicId || file.dontUpload) {
                    continue;
                }
                var response = file.response;
                // Fichier en cours d'upload
                if (file.active) {
                    anyActive = true;
                    this.onUploadStart();
                }
                // Fin d'upload
                else if (response && ("code" in response || "publicId" in response)) {
                    var resp = response;
                    if (file.__validating) {
                        if (resp.code == 0) {
                            file.__invalid = true;
                            file.__message = resp.message;
                        }
                        file.__validating = false;
                    }
                    else {
                        file.publicId = resp.publicId;
                        file.renderContent = resp.renderContent;
                        file.hasError = resp.hasError;
                    }
                    file.postAction = null;
                }
            }
            var f = this.getValidInputFiles();
            if (f.every(function (_) { return _.progress == 100 && _.success && _.publicId; })) {
                setTimeout(function () { return _this.onUploadEnd(); }, 100);
            }
            this.$emit("input", files);
        },
        getFileTypeLabel: function (id) {
            var fileType = this.fileTypeLabels.find(function (_) { return _.id == id; });
            if (fileType) {
                return fileType.label;
            }
            return "";
        },
        docWillReplace: function (doc) {
            if (doc.fileType == 0) {
                return false;
            }
            var existingDocs = this.$root.$data.existingDocs;
            return existingDocs &&
                existingDocs.length > 0 &&
                existingDocs.find(function (_) { return _.uniqueBc && _.fileType == doc.fileType; });
        },
        getChunkOptions: function () {
            return __assign({}, this.chunkOptions, {
                startAction: "/Ged/ChunkStart",
                uploadAction: "/Ged/ChunkUpload",
                finishAction: this.currentPostAction,
                finishBody: this.internalData,
                handler: ChunkUploadHandler_1.default,
                minSize: 4 * 1024 * 1024
            });
        },
        getPredicateValue: function () {
            return this.files.length + this.getValidInputFiles().length;
        },
        /**
         * Construit une URL de téléchargement
         */
        getUrl: function (publicId) {
            return "/Ged/Download/" + publicId;
        },
        /**
         * Construit une URL de visualisation
         */
        getPreviewUrl: function (publicId) {
            return "/Ged/PreviewModal/" + publicId;
        },
        /**
         * Méthode appelée en permanance au moindre changement sur les fichiers
         */
        onUploadInput: function (files) {
            var _this = this;
            files = files.filter(function (f) { return _this.validateInputFile(f); });
            var needsServerSideValidation = this.needsServerSideValidation();
            for (var _i = 0, files_2 = files; _i < files_2.length; _i++) {
                var file = files_2[_i];
                if (!file.fileType) {
                    file.fileType = this.fileListType;
                }
                if (needsServerSideValidation && !("__validating" in file)) {
                    file.__validating = true;
                }
            }
            this.onInput(files);
            if (needsServerSideValidation) {
                this.start();
            }
        },
        startFile: function (file) {
            file.data = __assign({}, file.data || {}, { fileType: file.fileType, fileName: file.name });
            file.editing = false;
            file.postAction = this.currentPostAction;
        },
        start: function () {
            var _this = this;
            this.getValidInputFiles().forEach(function (file) {
                _this.startFile(file);
            });
            this.$refs.fileInput.active = true;
        },
        stop: function () {
            this.$refs.fileInput.active = false;
        },
        startRealUpload: function () {
            var _this = this;
            this.getValidInputFiles().forEach(function (file) {
                _this.$refs.fileInput.update(file, {
                    active: true,
                    progress: "0.00",
                    success: false,
                    response: {},
                    chunk: undefined
                });
            });
            this.currentPostAction = this.postAction;
            this.start();
        },
        validateBeforeSubmit: function () {
            var validInputFiles = this.getValidInputFiles();
            if (this.required && validInputFiles.length + this.files.length == 0) {
                return false;
            }
            if (validInputFiles.find(function (f) { return f.fileType == 0; })) {
                return false;
            }
            return true;
        },
        getValidInputFiles: function () {
            return this.inputFiles.filter(function (f) { return !f.__invalid; });
        },
        /**
         * Déclenche la validation des fichiers, si elle est spécifiée
         */
        validateInputFile: function (file) {
            var extensions = this.getListExtensionAllowed();
            if (extensions.length > 0) {
                var ext = this.getFileExtension(file.name);
                if (extensions.indexOf(ext) === -1) {
                    file.postAction = null;
                    file.active = false;
                    file.__invalid = true;
                    file.__message = "Extension invalide, autorisées : " + extensions.join(', ');
                    return false;
                }
            }
            if (!this.validator || this.validator == 0) {
                return true;
            }
            return true;
        },
        /**
         * Marque un fichier comme à supprimer
         */
        deleteFile: function (file) {
            // Je récupère l'index de l'élément que je veux supprimer
            var indexItem = this.files.indexOf(file);
            if (indexItem === -1) {
                indexItem = this.inputFiles.indexOf(file);
                if (indexItem === -1) {
                    return;
                }
                this.inputFiles.splice(indexItem, 1);
            }
            else {
                this.files[indexItem].deleted = !this.files[indexItem].deleted;
            }
        },
        /**
         * Récupère l'extension du fichier
         */
        getFileExtension: function (fileName) {
            return $.getFileExtension(fileName);
        },
        /**
         * Récupère la class fa correspondante à l'extension du fichier
         */
        getFileExtensionCss: function (fileName) {
            return $.getFileExtensionCss(fileName);
        },
        /**
         * Renvoie la liste des extensions autorisées
         */
        getListExtensionAllowed: function () {
            return this.allowedExtensions ? this.allowedExtensions.toLowerCase().split(/\s*[,;]\s*/) : [];
        },
        /**
         * Indique si on a un validateur à éxécuter côté server
         */
        needsServerSideValidation: function () {
            return this.validator > 0;
        },
        /**
         * Affichage du champ de renommage de fichier
         */
        changeName: function (file) {
            // on peut pas maj sans tout parcourir ...
            this.$set(this.$data, "inputFiles", this.inputFiles.map(function (f) {
                if (f.id === file.id) {
                    f.editing = !f.editing;
                }
                else {
                    f.editing = false;
                }
                return f;
            }));
        }
    },
    computed: {
        serializedValue: function () {
            return JSON.stringify(this.files.concat(this.getValidInputFiles().map(function (f) {
                return {
                    fileName: f.name || f.fileName,
                    fileSize: f.size || f.fileSize,
                    fileType: f.fileType,
                    publicId: f.publicId,
                };
            })));
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/UploadFile.vue
// module id = 179
// module chunks = 0